import { useSelector } from "react-redux"

export const useLatestCameraState = ({ 
  serial,
  defaultState = 0,
}) => {
  const updatedState = useSelector((state) => (state.cameraStatesUpdate || {})[serial]);

  if (typeof updatedState !== "undefined") {
    return updatedState;
  }

  return defaultState;
};
